export const headingSemanticTokens = {
  text: {
    blue: { value: "{colors.green.500}" },
    black: { value: "{colors.primary.black}" },
    white: { value: "{colors.primary.white}" },
  },
  fontSizes: {
    sm: { value: "{fontSizes.sm}" }, // 14px
    md: { value: "{fontSizes.md}" }, // 16px
    lg: { value: "{fontSizes.lg}" }, // 18px
    xl: { value: "{fontSizes.xl}" }, // 20px
    "2xl": { value: "{fontSizes.2xl}" }, // 24px
    "3xl": { value: "{fontSizes.3xl}" }, // 26px
    "4xl": { value: "{fontSizes.4xl}" }, // 30px
    "5xl": { value: "{fontSizes.5xl}" }, // 44px
    "6xl": { value: "{fontSizes.6xl}" }, // 50px
  },
  fontWeights: {
    normal: { value: "{fontWeights.normal}" },
    bold: { value: "{fontWeights.bold}" },
  },
};
